export enum enumAuthorizationMethod {
  'Default' = 1,
  'User SMS',
  'User USSD',
  'PortalAuth',
  'Card Swipe',
  'Batch Card',
  'Third Party',
  'ATA Authed',
  'NI-USSD',
  'None',
  'Incoming Specified'
}

export namespace enumAuthorizationMethod {
  export function values() {
    return Object.keys(enumAuthorizationMethod).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
